;(function(jQuery) {
	"use strict";

	function ProgressBar()
	{
		var pub = {};

		var fn = {
			init: function()
			{
				pub.updateProgress = fn.updateProgress;
			},

			updateProgress: function(step, total)
			{
				var percentage = Math.round(step / total * 100);
				jQuery('.js-flo-progress-bar').css('width', percentage + '%');
			},
		}

		fn.init();

		return pub;
	}

	window.ProgressBar = new ProgressBar();
})(jQuery);